// components/Pagination.js

export default function Pagination({ currentPage, totalPages, onPageChange }) {
  const safeTotalPages = totalPages < 1 ? 1 : totalPages; // Sayfa sayısının en az 1 olmasını sağlıyoruz

  return (
    <div className="pagination">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Geri
      </button>
      <span>
        Sayfa {currentPage} / {safeTotalPages}
      </span>
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === safeTotalPages}
      >
        İleri
      </button>
    </div>
  );
}
